import { dianaAIQuery, useOnboardingStore } from '@diana/core';
import { useIndustryOptions } from './useIndustryOptions';
import { useMutation } from '@tanstack/react-query';

export const useCompanyResearch = ({ saveAiAreas = false }: { saveAiAreas?: boolean } = {}) => {
  const industryList = useIndustryOptions();

  const setAiAreas = useOnboardingStore((store) => store.setAiAreas);
  const setResearch = useOnboardingStore((store) => store.setResearch);
  const setIndustry = useOnboardingStore((store) => store.setIndustry);

  const companyResearchQuery = dianaAIQuery.companyResearch();

  return useMutation({
    mutationKey: companyResearchQuery.key,
    mutationFn: ({
      email,
      companyName,
      industries,
    }: {
      email: string;
      companyName: string;
      industries?: string[];
    }) => companyResearchQuery.fn({ industries: industries ?? industryList, email, companyName }),
    onSuccess: (data) => {
      const { research, industry, areas_for_improvement } = data;
      if (saveAiAreas) {
        setAiAreas(areas_for_improvement);
      }
      setIndustry(industry);
      setResearch({ research, industry });
    },
  });
};
